import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { PartnerAccountPanelProps } from './types';
import { styles } from './styles';
import { Button, CollapsiblePanel } from '@v2/components';
import PartnerAccount from '../PartnerAccount';

const PartnerAccountPanel: React.FC<PartnerAccountPanelProps> = ({
  accounts,
  partnerId,
  handleAddAccount,
  onAccountRemoved,
}) => {
  return (
    <CollapsiblePanel title={`Accounts (${accounts.length})`} defaultExpanded={true}>
      <div className={styles.container}>
        <div className={styles.header}>
          <span className={styles.title}>
            {accounts.length > 0
              ? `${accounts.length} ${accounts.length === 1 ? 'account' : 'accounts'}`
              : 'No accounts for this partner'}
          </span>
          <Button
            variant="ghost-success"
            size="sm"
            onClick={handleAddAccount}
            icon={<FontAwesomeIcon icon={faPlus} />}>
            Add Account
          </Button>
        </div>
        {accounts.length > 0 && (
          <div className={styles.grid}>
            {accounts.map(account => (
              <PartnerAccount
                key={account.id}
                account={account}
                partnerId={partnerId}
                onRemoved={onAccountRemoved}
              />
            ))}
          </div>
        )}
      </div>
    </CollapsiblePanel>
  );
};

export default PartnerAccountPanel;
